import { ColorOptions, Icon, IconButton, Loader, ModBox, Spacer, Text } from '@jfs/ui-new'
import { ButtonNew } from '../../../../components/AdminButton'
import { EmType } from '../..'
import { accessConfig } from '../../../../network/accessConfig'
import { isAccessible } from '../../../../utils'

interface StatusCompProps {
  isLoading?: boolean
  showSuccess: boolean
  type: any
  failedErrorMsg?: string
  isCreateSuccess: boolean
  onBackPress: any
  isStatusSuccess?: boolean
  applicationId: any
  businessName: any
  isUserCreationPressed: boolean
  navigateToMyAppQueue: any
  navigateToCreateGroup: any
}

export const StatusComp = ({
  isLoading = false,
  showSuccess,
  type,
  failedErrorMsg = '',
  isCreateSuccess = true,
  onBackPress,
  isStatusSuccess = true,
  applicationId,
  businessName,
  isUserCreationPressed,
  navigateToMyAppQueue,
  navigateToCreateGroup,
}: StatusCompProps) => {
  const typeTitle = `${
    type === EmType.createSingleEntity ? 'Entity' : type === EmType.createSubGroup ? 'SubGroup' : 'Group'
  }`

  const getStatusTitle = () => {
    if (!isLoading) {
      if (type === EmType.createSingleEntity) {
        return isStatusSuccess
          ? `Your ${typeTitle} creation application submitted and is pending for approval.\n You can check further status from your 'Application Queue'`
          : `Sorry, we couldn’t create the ${typeTitle}.\n${failedErrorMsg} \nPlease try again later.`
      } else if (type === EmType.createGroup) {
        return isCreateSuccess
          ? `Your ${typeTitle} creation application submitted. and is pending for approval.\n You can check further status from your 'Application Queue'`
          : `Sorry, we couldn’t create the ${typeTitle}.\n${failedErrorMsg} \nPlease try again later.`
      } else {
        return isCreateSuccess
          ? `Your ${typeTitle} creation application submitted and is pending for approval.\n You can check further status from your 'Application Queue'`
          : `Sorry, we couldn’t create the ${typeTitle}.\n${failedErrorMsg} \nPlease try again later.`
      }
    }
  }

  const getStatus = () => {
    if (type === EmType.createGroup || type === EmType.createSubGroup) {
      return isCreateSuccess
    }
    if (type === EmType.createSingleEntity) {
      return isStatusSuccess
    }
  }
  return (
    <>
      <ModBox h={'100%'} show={isLoading} alignItems={'center'} justify={'center'}>
        <Loader type={'large'} color="PRIMARY" />
      </ModBox>
      <ModBox
        show={!isLoading}
        alignItems={'center'}
        justify={'center'}
        h={'100%'}
        minHeight={500}
        overflow={'auto'}
        testID="vertical-scroll">
        <ModBox
          show={type === EmType.myQueue}
          borderBottomWidth={1}
          borderBottomColor={'BORDER_COLOR'}
          direction={'row'}
          h={71}
          alignItems={'center'}
          justify={'flex-start'}>
          <ModBox>
            <IconButton id="ARROW_BACK" size={24} color={'#0070B6' as ColorOptions} onPress={onBackPress} />
          </ModBox>
          <Spacer size={16} direction={'horizontal'} />
          <Text title={'Status Details'} color={'BLACK_21'} fontSize={18} fontFamily={'jiotype-bold'} />
        </ModBox>
        <ModBox
          show={showSuccess && !isLoading}
          justifyContent={'center'}
          alignItems={'center'}
          ph={80}
          pv={24}
          minWidth={552}
          h={'100%'}
          minHeight={'100%'}>
          <ModBox show={!isLoading}>
            <ModBox width={'100%'} alignItems={'center'} justifyContent={'center'}>
              <ModBox
                w={64}
                h={64}
                borderRadius={32}
                backgroundColor={'#FBEDD6' as ColorOptions}
                alignItems={'center'}
                justifyContent={'center'}>
                <Icon
                  id={getStatus() ? 'STATUS_AWAITING' : 'CLOSE'}
                  color={getStatus() ? ('#E68E00' as ColorOptions) : 'RED'}
                  size={32}
                />
                <ModBox show={false} position={'absolute'} bottom={0} right={-10}>
                  <Icon
                    id={getStatus() ? 'SUCCESSFUL_FILLED' : 'CLEAR'}
                    color={getStatus() ? ('#E68E00' as ColorOptions) : 'RED'}
                    size={25}
                  />
                </ModBox>
              </ModBox>
            </ModBox>
            <ModBox marginTop={32} alignItems={'center'} justifyContent={'center'}>
              <ModBox>
                <Text
                  title={getStatusTitle()}
                  color={'BLACK_21'}
                  fontSize={16}
                  fontFamily={'jiotype-bold'}
                  textAlign={'center'}
                />
                <ModBox show={type === EmType.createSingleEntity ? isStatusSuccess : isCreateSuccess}>
                  <ModBox marginTop={32} alignItems={'center'} justifyContent={'center'}>
                    <ModBox alignItems={'center'} justifyContent={'center'}>
                      <Text title={'Application ID'} color={'BLACK_75'} fontSize={12} fontFamily={'jiotype-medium'} />
                      <Text title={applicationId} color={'BLACK_21'} fontSize={12} fontFamily={'jiotype-bold'} />
                    </ModBox>

                    <ModBox
                      marginTop={32}
                      alignItems={'center'}
                      justifyContent={'center'}
                      show={businessName?.length > 0}>
                      <Text title={'Business Name'} color={'BLACK_75'} fontSize={12} fontFamily={'jiotype-medium'} />
                      <Text title={businessName} color={'BLACK_21'} fontSize={12} fontFamily={'jiotype-bold'} />
                    </ModBox>
                  </ModBox>
                </ModBox>
                <Spacer direction="vertical" size={40} />
                <ModBox direction="row" alignItems={'center'} justifyContent={'center'}>
                  <ModBox show={true}>
                    <ButtonNew
                      height={40}
                      width={227}
                      hide={isUserCreationPressed || !isCreateSuccess}
                      type={'secondaryIcon'}
                      title={isAccessible(accessConfig, 'approve') ? 'Go to my Application Queue' : 'Go to Maker Queue'}
                      onPress={navigateToMyAppQueue}
                      borderColor={'#0070B6' as ColorOptions}
                    />
                  </ModBox>
                  <Spacer direction="horizontal" size={16} />
                  <ButtonNew
                    height={40}
                    width={227}
                    type={'secondaryIcon'}
                    title={`Create new ${typeTitle}`}
                    onPress={navigateToCreateGroup}
                    borderColor={'#0070B6' as ColorOptions}
                  />
                </ModBox>
              </ModBox>
            </ModBox>
          </ModBox>
        </ModBox>
      </ModBox>
    </>
  )
}
